<template>
    <div style="height: 100%; width: 100%;">
        <div class="header">
            <div class="title-container">
                <h3>Détails employé</h3>
            </div>
        </div>
        <div class="cards-container">
            <div class="left-container">
                <div class="first-row">
                    <b-card class="user-card">
                        <b-avatar class="mb-2"></b-avatar>
                        <h3>{{ user.firstname }} {{ user.lastname }}</h3>
                        <p>{{ user.job }}</p>
                        <p class="subtitle" v-b-modal.modal-1>Afficher informations détaillées <i
                                class="fas fa-search"></i></p>
                        <b-modal class="modal1" id="modal-1" title="Informations personnelles" scrollable centered>
                            <p class="my-4">Nom : {{ user.lastname }}</p>
                            <p class="my-4">Prénom : {{ user.firstname }}</p>
                            <p class="my-4">Téléphone : {{ user.personal_mobile ? user.personal_mobile : 'Non renseigné'
                                }}</p>
                            <p class="my-4">E-mail : {{ user.email ? user.email : 'Non renseigné' }}</p>
                            <b-button variant="default" v-b-toggle="'collapse-1'" block class="d-flex">
                                <span>Horraires</span>
                                <strong v-if="isVisible" aria-hidden="true" class="ml-auto">-</strong>
                                <strong v-else aria-hidden="true" class="ml-auto">+</strong>
                            </b-button>
                            <br>
                            <b-collapse id="collapse-1" v-model="isVisible">
                                <b-card class="horaire-card">
                                    <b-form @submit.prevent="updateTTChanges">
                                        <b-form-group label="Lundi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_lundi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Mardi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_mardi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Mercredi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_mercredi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Jeudi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_jeudi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Vendredi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_vendredi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Samedi:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_samedi"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group label="Dimanche:">
                                            <b-form-input id="TT-input" v-if="user.array_options"
                                                v-model="user.array_options.options_horaire_dimanche"
                                                :disabled="!isEditing" :class="{ 'disabled-input': !isEditing }">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-button v-if="isAdmin=='1'" style="margin-right: 10px;" variant="primary"
                                            @click="enableEdit">Modifier</b-button>
                                        <b-button v-if="isAdmin=='1'" style="margin-left: 10px;" type="submit" variant="success"
                                            :disabled="!isEditing">Valider</b-button>
                                    </b-form>
                                </b-card>
                            </b-collapse>
                            <template #modal-footer class="detail-modal-footer">
                                <div style="display: flex; gap: 10px;" class="right_buttons_container">
                                    <b-button variant="danger" @click="$bvModal.hide('modal-1')">
                                        Fermer
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                    </b-card>
                    <b-card text-variant="white" header="Etat de présence" class="working-card text-center">
                        <div class="icon-container">
                            <span v-if="user.array_options.options_travail_en_cours === '1'" class="far fa-check-circle"
                                style="height: 100%; color: green; width: 100%;"></span>
                            <span v-if="user.array_options.options_travail_en_cours === '0'" class="far fa-times-circle"
                                style="height: 100%; color: red; width: 100%;"></span>
                        </div>
                    </b-card>

                </div>
                <div class="second-row">
                    <b-card class="events-list-card">
                        <div style="display: flex; flex-direction: row; justify-content: space-between; border: none; margin-bottom: 10px"
                            class="header">
                            <h3 style="margin-bottom: 10px;">
                                Historique des pointages
                            </h3>
                            <b-button v-if="isAdmin == '1'" variant="primary" v-b-modal.createPointageModal>Nouveau
                                pointage</b-button>
                            <b-button v-if="isAdmin == '0' && user.array_options.options_travail_en_cours === '0'"
                                variant="success" @click="createEntryEvent">Pointage Entrée</b-button>
                            <b-button v-if="isAdmin == '0' && user.array_options.options_travail_en_cours === '1'"
                                variant="danger" @click="createExitEvent">pointage Sortie</b-button>
                        </div>
                        <b-container v-for="event in lastEvents" :key="event.id">
                            <b-row style="height: 20%; text-align: center;">
                                <b-col cols="auto" class="text-center">
                                    <i v-if="event.isError" class="fas fa-exclamation-triangle"
                                        style="color: #FFD43B;"></i>
                                </b-col>
                                <b-col>
                                    <p :class="getClass(event)">
                                        {{ formatDate(event.datep) }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p :class="getClass(event)">
                                        {{ formatTime(event.datep) }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <p :class="getClass(event)">
                                        {{ event.label }}
                                    </p>
                                </b-col>
                                <b-col>
                                    <span>
                                        <i v-if="isAdmin == '1'" v-b-modal.detailsEventAdmin class="fas fa-search"
                                            @click="defineSelectedEvent(event)"></i>
                                        <i v-if="isAdmin == '0'" v-b-modal.detailsEvent class="fas fa-search"
                                            @click="defineSelectedEvent(event)"></i>
                                    </span>
                                </b-col>
                            </b-row>
                        </b-container>

                        <b-modal id="createPointageModal" title="Nouvel Évènement" scrollable centered>
                            <template>
                                <b-form>
                                    <b-row class="input_row">
                                        <b-col>
                                            <label for="event_label">Libellé : </label>
                                        </b-col>
                                        <b-col>
                                            <b-form-select v-model="newEvent.label" id="event_label">
                                                <b-form-select-option value="Pointage entrée">Pointage
                                                    entrée</b-form-select-option>
                                                <b-form-select-option value="Pointage sortie">Pointage
                                                    sortie</b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="input_row">
                                        <b-col>
                                            <label for="event_date">Date : </label>
                                        </b-col>
                                        <b-col>
                                            <b-form-datepicker id="event_date" v-model="newEvent.event_date"
                                                locale="fr"></b-form-datepicker>
                                        </b-col>
                                    </b-row>
                                    <b-row class="input_row">
                                        <b-col>
                                            <label for="event_hour">Heure : </label>
                                        </b-col>
                                        <b-col>
                                            <b-form-timepicker id="event_hour" v-model="newEvent.event_time"
                                                locale="fr"></b-form-timepicker>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </template>

                            <template #modal-footer>
                                <b-button variant="danger"
                                    @click="$bvModal.hide('createPointageModal')">Annuler</b-button>
                                <b-button @click="createPointage(newEvent)" variant="success">Ajouter</b-button>
                            </template>
                        </b-modal>


                        <b-modal id="detailsEventAdmin" title="Détails de l'évènement" scrollable centered>
                            <template>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_label">Libellé : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-select v-model="selectedEvent.label" id="event_label">
                                            <b-form-select-option value="Pointage entrée">Pointage
                                                entrée</b-form-select-option>
                                            <b-form-select-option value="Pointage sortie">Pointage
                                                sortie</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_date">Date : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-datepicker id="event_date" v-model="selectedEvent.event_date"
                                            locale="fr"></b-form-datepicker>
                                    </b-col>
                                </b-row>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_hour">Heure : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-timepicker id="event_hour" v-model="selectedEvent.event_time"
                                            locale="fr"></b-form-timepicker>
                                    </b-col>
                                </b-row>
                            </template>
                            <template #modal-footer class="detail-modal-footer">
                                <div class="delete_button_container">
                                    <b-button variant="danger" @click="detetePointage(selectedEvent.id)">
                                        Supprimer
                                    </b-button>
                                </div>
                                <div style="display: flex; gap: 10px;" class="right_buttons_container">
                                    <b-button variant="danger" @click="$bvModal.hide('detailsEventAdmin')">
                                        Annuler
                                    </b-button>
                                    <b-button variant="success" @click="confirmUpdate(selectedEvent)">
                                        Modifier
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>

                        <b-modal id="detailsEvent" title="Détails de l'évènement" scrollable centered>
                            <template>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_label">Libellé : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-select disabled="true" v-model="selectedEvent.label" id="event_label">
                                            <b-form-select-option value="Pointage entrée">Pointage
                                                entrée</b-form-select-option>
                                            <b-form-select-option value="Pointage sortie">Pointage
                                                sortie</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_date">Date : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-datepicker disabled="true" id="event_date"
                                            v-model="selectedEvent.event_date" locale="fr"></b-form-datepicker>
                                    </b-col>
                                </b-row>
                                <b-row class="input_row">
                                    <b-col>
                                        <label for="event_hour">Heure : </label>
                                    </b-col>
                                    <b-col>
                                        <b-form-timepicker disabled="true" id="event_hour"
                                            v-model="selectedEvent.event_time" locale="fr"></b-form-timepicker>
                                    </b-col>
                                </b-row>
                            </template>
                            <template #modal-footer class="detail-modal-footer">
                                <div style="display: flex; gap: 10px;" class="right_buttons_container">
                                    <b-button variant="danger" @click="$bvModal.hide('detailsEvent')">
                                        Fermer
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>

                        <p class="centered-subtitle" v-b-modal.modal-2>Afficher l'historique complet <i
                                class="fas fa-search"></i>
                        </p>

                    </b-card>

                    <b-modal class="modal1" id="modal-2" title="Historique des pointages" scrollable centered>
                        <template #modal-header>
                            <h5 class="modal-title">Historique des pointages</h5>
                        </template>

                        <b-table id="table-headers" :items="events" :fields="fieldsTableHistoric" select-mode="multi"
                            responsive="sm" ref="selectableTable">
                            <template #cell(time)="row">
                                <span :class="{ 'error-text': row.item.isError }">{{ formatDate(row.item.datep)
                                    }}</span>
                            </template>
                            <template #cell(label)="row">
                                <span :class="{ 'error-text': row.item.isError }">{{ row.item.label }}</span>
                            </template>
                            <template #cell(icon)="row">
                                <span><i v-b-modal.detailsEvent class="fas fa-search"
                                        @click="defineSelectedEvent(row.item)"></i></span>
                            </template>
                        </b-table>

                        <template #modal-footer>
                            <b-button variant="secondary" @click="$bvModal.hide('modal-2')">Fermer</b-button>
                        </template>
                    </b-modal>
                </div>
                <div class="third-row">
                    <b-row class="row">
                        <b-col>
                            <b-card bg-variant="danger" text-variant="white" header="Erreurs de pointage"
                                class="errors-card" @click="getErrorsList" v-b-modal.errors-list-modal>
                                <b-card-text class="text-center">{{ pointageErrors }}</b-card-text>
                            </b-card>
                        </b-col>
                        <b-modal class="modal1" id="errors-list-modal" title="Erreurs de pointage" scrollable centered>
                            <template #modal-header>
                                <h5 class="modal-title">Erreurs de pointage</h5>
                            </template>

                            <b-table id="table-headers" :items="errorsList" :fields="fieldsTableErrors"
                                select-mode="multi" responsive="sm" ref="selectableTable">
                                <template #cell(date)="row">
                                    <span :class="{ 'error-text': row.item.isError }">{{ formatDate(row.item.datep)
                                        }}</span>
                                </template>
                                <template #cell(time)="row">
                                    <span :class="{ 'error-text': row.item.isError }">{{ formatTime(row.item.datep)
                                        }}</span>
                                </template>
                                <template #cell(label)="row">
                                    <span :class="{ 'error-text': row.item.isError }">{{ row.item.label }}</span>
                                </template>
                                <template #cell(icon)="row">
                                    <span><i v-if="isAdmin=='1'" v-b-modal.detailsEventAdmin class="fas fa-search"
                                            @click="defineSelectedEvent(row.item)"></i>
                                            <i v-if="isAdmin=='0'" v-b-modal.detailsEvent class="fas fa-search"
                                            @click="defineSelectedEvent(row.item)"></i>
                                    </span>
                                </template>
                            </b-table>

                            <template #modal-footer>
                                <b-button variant="secondary"
                                    @click="$bvModal.hide('errors-list-modal')">Fermer</b-button>
                            </template>
                        </b-modal>
                        <b-col>
                            <b-card bg-variant="success" text-variant="white" header="Heures supplémentaires effectuées"
                                class="extra-card">
                                <b-card-text class="text-center">{{ extraHours.toFixed(1) }}h</b-card-text>
                            </b-card>
                        </b-col>
                        <b-col>
                            <b-card text-variant="white" header="% de pointages erronés" class="percentage_errors_card">
                                <b-card-text class="text-center">{{ percentageErrors }}%</b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="right-container">
                <b-row style="height: 30%;">
                    <b-col>
                        <b-card class="time-cards">
                            <h4>Heures effectuées aujourd'hui</h4>
                            <p>{{ hoursWorkedToday.toFixed(2) }}</p>
                            <!-- <canvas id="dailyHoursChart"></canvas> -->
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card class="time-cards">
                            <h4>Heures effectuées cette semaine</h4>
                            <p>{{ hoursWorkedWeek.toFixed(2) }}</p>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card class="time-cards">
                            <h4>Heures effectuées ce mois</h4>
                            <p>{{ hoursWorkedMounth.toFixed(2) }}</p>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row class="second-right-row">
                    <b-card id="calendar-card">
                        <FullCalendar id="calendar" :options="calendarOptions" />
                    </b-card>
                </b-row>
            </div>

        </div>

    </div>
</template>

<script>
import script from '../../../script/script.js';
import * as moment from 'moment'
import * as he from 'he'
import config from '../../../config/config';
import script_pointage from '../../../script/script_pointage.js';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import Swal from 'sweetalert2';
//import Chart from 'chart.js/auto';

export default {
    components: {
        FullCalendar, //Créer un composant FullCalendar pour pouvoir utiliser la balise <FullCalendar>
    },
    data() {
        return {
            events: {},
            lastEvents: {},
            selectedEvent: {},
            newEvent: {},
            user: {},
            formatedEventsList: [],
            errorsList: [],
            isEditing: false,
            originalOptions: null,
            hoursWorkedToday: 0,
            hoursWorkedMounth: 0,
            hoursWorkedWeek: 0,
            extraHours: 0,
            pointageErrors: 0,
            isSelectionMode: false,
            percentageErrors: 0,
            eventDetails: false,
            isAdmin: localStorage.getItem('admin')
        }
    },

    mounted() {
        //this.renderChart();
    },
    computed: {

        codeCommune() {
            return this.$route.params.codeCommune
        },
        idActus() {
            return this.$route.params.idActus
        },
        description() {
            return he.decode(this.event.note_private)
        },
        dateDebut() {
            return moment(parseFloat(this.event.datep * 1000)).locale('fr').format('dddd Do MMMM YYYY');
        },
        dateFin() {
            return moment(parseFloat(this.event.datef * 1000)).locale('fr').format('dddd Do MMMM YYYY');
        },
        fieldsTableHistoric() {
            var fields = [
                {
                    key: 'time',
                    label: 'Date de pointage',
                    sortable: true
                },
                {
                    key: 'label',
                    label: 'Entrée/Sortie',
                    sortable: true
                }
            ]
            return fields
        },
        fieldsTableErrors() {
            var fields = [
                {
                    key: 'date',
                    label: 'Date',
                    sortable: true
                },
                {
                    key: 'time',
                    label: 'Heure',
                    sortable: false
                },
                {
                    key: 'label',
                    label: 'Entrée/Sortie',
                    sortable: true
                },
                {
                    key: 'icon',
                    label: '',
                    sortable: false,
                }
            ]
            return fields
        },
        calendarOptions() {
            return {
                locale: 'fr',
                firstDay: 1,
                weekday: 'long',
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridWeek',
                events: this.formatedEventsList,
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,dayGridDay'
                },
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                },
                eventClick: this.defineSelectedEvent
            }
        },
    },

    async created() {
        await this.displayEmployeeDetails(this.$route.params.id);
        await this.displayEmployeeEvents(this.$route.params.id);
        this.lastEvents = this.events.slice(0, config.nbPointageHistoryDisplayed)
        await this.calculateDailyWorkedHours(this.events);
        await this.calculateWorkedHoursForWeek(this.events);
        await this.calculateMounthlyWorkedHours(this.events);
        await this.detectPointageErrors(this.events);
        this.percentageErrors = await this.calculatePercentageErrors(this.events);
        this.formatedEventsList = await this.formateEventsList(this.events);
        this.calendarOptions.events = this.formatedEventsList;
    },
    methods: {
        getEmployee: script_pointage.getUserById,
        getEmployeeEvents: script_pointage.getPointageEventsByUserId,
        getEventById: script_pointage.getEventById,
        modifyEvent: script_pointage.modifyEvent,
        modifyUserTT: script_pointage.modifyUserTempsTravail,
        createEvent: script_pointage.createEvent,
        modifyUserState: script_pointage.modifyUserState,
        deteteEvent: script_pointage.deleteEvent,

        reloadPage() {
            window.location.reload()
        },

        enableEdit() {
            if (this.isEditing === false) {
                this.isEditing = true;
                this.originalOptions = { ...this.user.array_options };
            } else {
                this.cancelEdit()
            }
        },

        cancelEdit() {
            this.user.array_options = { ...this.originalOptions }; // Restaurer les valeurs originales
            this.isEditing = false;
        },

        async updateTTChanges() {
            try {
                const horaires = {
                    options_horaire_lundi: this.user.array_options.options_horaire_lundi,
                    options_horaire_mardi: this.user.array_options.options_horaire_mardi,
                    options_horaire_mercredi: this.user.array_options.options_horaire_mercredi,
                    options_horaire_jeudi: this.user.array_options.options_horaire_jeudi,
                    options_horaire_vendredi: this.user.array_options.options_horaire_vendredi,
                    options_horaire_samedi: this.user.array_options.options_horaire_samedi,
                    options_horaire_dimanche: this.user.array_options.options_horaire_dimanche,
                }
                if (this.validateTimeOptions()) {
                    console.log('Format valide')
                    await this.modifyUserTT(this.user.id, horaires);
                    console.log('Modifications effectuées avec succès !')
                    window.location.reload();
                } else {
                    console.error('Format des données invalide')
                }
            } catch (error) {
                console.error(error)
            }
        },

        validateTimeOptions() {
            const timePattern = /^\d{2}h\d{2};\d{2}h\d{2};\d{2}h\d{2};\d{2}h\d{2}$/;
            const options = this.user.array_options;
            const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

            for (let day of days) {
                const timeString = options[`options_horaire_${day}`];
                if (!timePattern.test(timeString)) {
                    console.error(`Format invalide pour ${day}: ${timeString}`);
                    return false;
                }
            }
            return true;
        },

        defineSelectedEvent(event) {
            if (event.event !== undefined) {
                this.selectedEvent = { ...event.event, event_date: event.event.datep, event_time: event.event.datep }
                var formatedDate = moment(this.selectedEvent.event_date * 1000).local('fr').format('YYYY-MM-DD')
                var formatedTime = moment(this.selectedEvent.event_time * 1000).local('fr').format('HH:mm:ss')
                this.selectedEvent.event_time = formatedTime
                this.selectedEvent.event_date = formatedDate
            }
            else {
                this.selectedEvent = { ...event, event_date: event.datep, event_time: event.datep }
                var formatedDate = moment(this.selectedEvent.event_date * 1000).local('fr').format('YYYY-MM-DD')
                var formatedTime = moment(this.selectedEvent.event_time * 1000).local('fr').format('HH:mm:ss')
                this.selectedEvent.event_time = formatedTime
                this.selectedEvent.event_date = formatedDate
            }
        },

        async createEntryEvent() {
            try {
                var event = {
                    event_date: moment().format('YYYY-MM-DD'), // Format de la date en YYYY-MM-DD
                    event_time: moment().format('HH:mm:ss'),   // Format de l'heure en 24h HH:mm:ss
                    label: 'Pointage entrée',
                }
                console.log(event);
                this.createPointage(event);
            } catch (error) {
                console.error("Erreur lors de la création de l'évènement", error);
            }
        },


        async createExitEvent() {
            try {
                var event = {
                    event_date: moment().format('YYYY-MM-DD'), // Format de la date en YYYY-MM-DD
                    event_time: moment().format('HH:mm:ss'),   // Format de l'heure en 24h HH:mm:ss
                    label: 'Pointage sortie',
                }
                console.log(event);
                this.createPointage(event);
            } catch (error) {
                console.error("Erreur lors de la création de l'évènement", error);
            }
        },

        async createPointage(newEvent) {
            console.log(newEvent)
            try {
                const dateInMillis = new Date(newEvent.event_date).getTime();
                const timeInMillis = this.convertToMilliseconds(newEvent.event_time);

                const combinedTimestamp = dateInMillis + (timeInMillis % (24 * 60 * 60 * 1000));
                const event = {
                    label: newEvent.label,
                    datep: combinedTimestamp / 1000,
                    userownerid: `${this.user.id}`,
                };

                if (event.label !== undefined & event.datep !== undefined & event.userownerid !== undefined) {
                    var response = await this.createEvent(event);
                    if (response) {
                        this.displayAlert("Succès", "Évènement créé avec succès", "success").then((result) => {
                            if (result.isConfirmed) {
                                this.checkUserState(this.user.id);
                                this.reloadPage()
                            }
                        });

                    }
                }
                else {
                    this.displayAlert("Error!", "Informations manquantes!", "error")
                }
            } catch (error) {
                console.error("Erreur lors de la création de l'événement", error);
            }
        },

        async detetePointage(id) {
            try {
                var response = await this.deteteEvent(id);
                if (response) {
                    await this.checkUserState(this.user.id);
                    this.reloadPage()
                }
            } catch (error) {
                console.error(error)
            }
        },

        async checkUserState(userid) {
            // Récupération de la date actuelle au format Unix (début de la journée, c'est-à-dire minuit)
            let todayStart = moment().startOf('day').unix(); // Unix timestamp (début de la journée)
            let todayEnd = moment().endOf('day').unix(); // Unix timestamp (fin de la journée)

            // Récupération des événements de l'utilisateur
            this.events = await this.getEmployeeEvents(userid);

            // Tri des événements par date décroissante (du plus récent au plus ancien)
            this.events = this.events.sort((a, b) => b.datep - a.datep);

            const lastEvent = this.events[0];

            if (lastEvent.label === 'Pointage entrée') {
                // Conversion de la date de l'événement en timestamp Unix
                const eventDate = lastEvent.datep;

                // Vérification si l'événement est entre le début et la fin de la journée
                if (eventDate >= todayStart && eventDate <= todayEnd) {
                    this.user.array_options.options_travail_en_cours = '1'; // Présent aujourd'hui
                } else {
                    this.user.array_options.options_travail_en_cours = '0'; // Non présent (pointage d'un autre jour)
                }
            } else if (lastEvent.label === "Pointage sortie") {
                this.user.array_options.options_travail_en_cours = '0'; // Sortie enregistrée
            }

            // Mise à jour de l'état de l'utilisateur
            await this.modifyUserState(userid, this.user.array_options.options_travail_en_cours);
        },




        async confirmUpdate(event) {

            try {
                const dateInMillis = new Date(event.event_date).getTime();
                const timeInMillis = this.convertToMilliseconds(event.event_time);

                const combinedTimestamp = dateInMillis + (timeInMillis % (24 * 60 * 60 * 1000));
                event.datep = combinedTimestamp / 1000;

                const response = await this.modifyEvent(event.id, event.label, event.datep);

                if (response) {
                    await this.checkUserState(this.user.id);
                    this.reloadPage()
                }
            } catch (error) {
                console.error("Erreur lors de la modification de l'événement", error);
            }
        },

        convertToMilliseconds(time) {
            const [hours, minutes, seconds] = time.split(':').map(Number);
            const now = new Date();
            now.setHours(hours, minutes, seconds, 0);
            return now.getTime();
        },

        Annuler() {
            this.selectedEvent
        },

        formatDate(timestamp) {
            var date = new Date(timestamp * 1000);
            return moment(date).locale('fr').format('dddd Do MMMM YYYY');
        },

        formatTime(timestamp) {
            var date = new Date(timestamp * 1000);
            return moment(date).locale('fr').format('HH:mm');
        },

        toggleSelectionMode() {
            this.isSelectionMode = !this.isSelectionMode;
            if (!this.isSelectionMode) {
                this.events.forEach(event => {
                    event.isSelected = false;
                });
            }
        },
        selectEvent(event) {
            if (this.isSelectionMode) {
                event.isSelected = !event.isSelected;
            }
        },
        deleteSelectedEvents() {
            this.events = this.events.filter(event => !event.isSelected);
            this.isSelectionMode = false;
        },

        async displayEmployeeDetails(id) {
            this.user = await this.getEmployee(id)
            return this.user;
        },

        async displayEmployeeEvents(id) {
            this.events = await this.getEmployeeEvents(id);
            this.events = this.events.map(event => {
                if (!event.datep || event.datep === "") {
                    event.datep = event.datec;
                }
                event.datep = event.datep
                return event;
            });
            this.events = this.events.sort((a, b) => b.datep - a.datep)
            this.checkUserState(id)
            return this.events;
        },

        calculateDailyWorkedHours(events) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const tomorrow = new Date(today).setDate(today.getDate() + 1);

            let totalHours = 0;

            for (let i = 1; i < events.length; i++) {
                if (events[i].label === "Pointage entrée" && events[i - 1].label === "Pointage sortie") {
                    const entryTime = new Date(events[i].datep * 1000);
                    const exitTime = new Date(events[i - 1].datep * 1000);

                    if (entryTime < tomorrow && exitTime >= today) {
                        const adjustedEntryTime = entryTime < today ? today : entryTime;
                        const adjustedExitTime = exitTime >= tomorrow ? tomorrow : exitTime;

                        const workedTime = adjustedExitTime - adjustedEntryTime;
                        totalHours += workedTime;
                    }
                }
            }

            this.hoursWorkedToday = totalHours / (1000 * 60 * 60);
        },

        calculateMounthlyWorkedHours(events) {
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

            let totalHours = 0;

            for (let i = 1; i < events.length; i++) {
                if (events[i].label === "Pointage entrée" && events[i - 1].label === "Pointage sortie") {
                    const entryTime = new Date(events[i].datep * 1000);
                    const exitTime = new Date(events[i - 1].datep * 1000);

                    if (entryTime <= endOfMonth && exitTime >= startOfMonth) {
                        const adjustedEntryTime = entryTime < startOfMonth ? startOfMonth : entryTime;
                        const adjustedExitTime = exitTime > endOfMonth ? endOfMonth : exitTime;

                        const workedTime = adjustedExitTime - adjustedEntryTime;
                        totalHours += workedTime;
                    }
                }
            }

            this.hoursWorkedMounth = totalHours / (1000 * 60 * 60);
            this.calculateExtraMounthlyHours(this.hoursWorkedMounth)
        },

        calculateExtraMounthlyHours(totalHours) {
            this.extraHours = totalHours - (this.user.weeklyhours * 52 / 12).toFixed(2)
            if (this.extraHours <= 0) {
                this.extraHours = 0
            }
        },

        calculateWorkedHoursForWeek(events) {
            const now = new Date();
            const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + (now.getDay() === 0 ? -6 : 1)));
            startOfWeek.setHours(0, 0, 0, 0);
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(endOfWeek.getDate() + 6);
            endOfWeek.setHours(23, 59, 59, 999);

            let totalHours = 0;

            for (let i = 1; i < events.length; i++) {
                if (events[i].label === "Pointage entrée" && events[i - 1].label === "Pointage sortie") {
                    const entryTime = new Date(events[i].datep * 1000);
                    const exitTime = new Date(events[i - 1].datep * 1000);

                    if (entryTime <= endOfWeek && exitTime >= startOfWeek) {
                        const adjustedEntryTime = entryTime < startOfWeek ? startOfWeek : entryTime;
                        const adjustedExitTime = exitTime > endOfWeek ? endOfWeek : exitTime;

                        const workedTime = adjustedExitTime - adjustedEntryTime;
                        totalHours += workedTime;
                    }
                }
            }

            this.hoursWorkedWeek = totalHours / (1000 * 60 * 60);
        },

        detectPointageErrors(events) {
            const weekdays = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
            let pointageErrors = 0;

            events.forEach((event, index) => {
                if (events[index].label === "Pointage entrée") {
                    const entryTime = new Date(events[index].datep * 1000);
                    const dayOfWeek = weekdays[entryTime.getDay()];
                    const scheduleKey = `options_horaire_${dayOfWeek}`;
                    const schedule = this.user.array_options[scheduleKey];
                    event.isError = false;

                    if (schedule) {
                        const [morningStart, morningEnd, afternoonStart, afternoonEnd] = schedule.split(';').map(time => {
                            const [hours, minutes] = time.split('h');
                            const tempDate = new Date(entryTime);
                            tempDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                            return tempDate;
                        });
                        if (events[index].label === "Pointage entrée") {
                            if (entryTime.getTime() > morningStart.getTime() && entryTime.getTime() < morningEnd.getTime() || entryTime.getTime() > afternoonStart.getTime() && entryTime.getTime() < afternoonEnd.getTime()) {
                                pointageErrors++;
                                event.isError = true;
                            }
                        }
                    }
                }
                else if (events[index].label === "Pointage sortie") {
                    const exitTime = new Date(events[index].datep * 1000);
                    const dayOfWeek = weekdays[exitTime.getDay()];
                    const scheduleKey = `options_horaire_${dayOfWeek}`;
                    const schedule = this.user.array_options[scheduleKey];
                    event.isError = false;

                    if (schedule) {
                        const [morningStart, morningEnd, afternoonStart, afternoonEnd] = schedule.split(';').map(time => {
                            const [hours, minutes] = time.split('h');
                            const tempDate = new Date(exitTime);
                            tempDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                            return tempDate;
                        });

                        if (events[index].label === "Pointage sortie") {
                            if (exitTime.getTime() > morningStart.getTime() && exitTime.getTime() < morningEnd.getTime() || exitTime.getTime() > afternoonStart.getTime() && exitTime.getTime() < afternoonEnd.getTime()) {
                                pointageErrors++;
                                event.isError = true;
                            }
                        }
                    }
                }

            });

            this.pointageErrors = pointageErrors;
            this.getErrorsList(events)
        },

        async calculatePercentageErrors(events) {
            if (!events || events.length === 0) {
                return 0;
            }
            const totalEvents = events.length;
            const totalErrorsEvents = events.filter(event => event.isError === true).length;
            var percentageErrors = ((totalErrorsEvents / totalEvents) * 100).toFixed(0);

            return percentageErrors
        },

        async formateEventsList(events) {
            return events.map(event => {
                // Remplace le label par 'Entrée' ou 'Sortie'
                let formattedLabel = '';
                if (event.label === 'Pointage entrée') {
                    formattedLabel = 'Entrée';
                } else if (event.label === 'Pointage sortie') {
                    formattedLabel = 'Sortie';
                } else {
                    formattedLabel = event.label; // Si le label n'est pas 'Pointage entrée' ou 'Pointage sortie', conserver l'original
                }

                return {
                    id: event.id,
                    title: formattedLabel, // Utilise le label formaté
                    date: event.datep * 1000,
                    display: 'block',
                    extendedProps: {
                        owner: event.userowerid
                    }
                };
            });
        },

        getClass(event) {
            return {
                'green-text': event.label === 'Pointage entrée',
                'red-text': event.label === 'Pointage sortie'
            };
        },

        getErrorsList(events) {
            this.errorsList = events.filter(event => event.isError === true);
            console.log(this.errorsList)
        },

        displayAlert(title, message, icon, buttonText) {
            return Swal.fire({
                title: title,
                text: message,
                icon: icon,
                confirmButtonText: buttonText
            })
        },


        /* renderChart() {
        const ctx = document.getElementById('dailyHoursChart').getContext('2d');
        const dailyHoursChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ['Heures travaillées'],
                datasets: [{
                    label: "Heures effectuées",
                    data: this.hoursWorkedToday,
                    backgroundColor: 'rgba(54, 162, 235, 0.2)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                },
                indexAxis: 'y', // Orientation horizontale
            }
        });
    }*/
    }
}
</script>

<style scoped>
b-row {
    margin-left: 15px;
    margin-right: 15px;
}

.green-text {
    color: green;
}

.red-text {
    color: red;
}

.header {
    width: 100%;
    height: 60px;
    background-color: #333;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 0.1px solid #bcbcbc;
}

.title-container {
    margin-left: 20px;
}

.title-container h3 {
    color: #fff;
}

.cards-container {
    height: calc(100%-60px);
    padding: 15px;
    background-color: #3f3f3f;
    display: flex;
    flex-direction: row;
    gap: 15px;
}

.left-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 50%;
}

.right-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 50%;
    height: 100%;
}

.time-cards {
    height: 100%;
    background-color: #323232;
    color: #fff;
}

.first-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.percentage_errors_card {
    background-color: #323232;
    color: #fff;
    height: 100%;
}

.user-card {
    width: 50%;
    height: 100%;
    border-radius: 5px;
    background-color: #323232;
    color: #fff;
}

.subtitle {
    color: lightgrey;
    font-size: x-small;
    text-decoration: underline;
    text-align: right;
}

.centered-subtitle {
    color: lightgrey;
    font-size: x-small;
    text-decoration: underline;
    text-align: center;
}

.events-list-card {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    background-color: #323232;
    color: #fff;
}

.errors-card {
    height: 100%;
}

.extra-card {
    height: 100%;
}

.working-card {
    width: 20%;
    height: 50%;
    background-color: #323232;
}

.error-text {
    color: red;
}

.icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.selected-event {
    background-color: #f5f5f5;
    /* Couleur de fond pour les événements sélectionnés */
}

.horaire-card {
    display: flex;
    flex-direction: column;
}


#detailsEvent {
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    background-color: #3f3f3f !important;
}

#detailsEventAdmin {
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    background-color: #3f3f3f !important;
}

.input_row {
    color: #fff;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.form-control {
    border: none;
}

.modal-content {
    height: 50%;
}

span {
    color: lightgrey;
}

.second-right-row {
    display: flex;
    align-items: center;
    padding: 15px;
    height: 65%;
}

.horaire-card {
    background-color: #323232;
    color: #fff;
    border: none;
}
</style>

<style>
#detailsEvent___BV_modal_footer_.modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between !important;
}

#detailsEventAdmin___BV_modal_footer_.modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between !important;
}

#modal-1 .modal-content {
    background-color: #323232;
    color: #fff;
}

#TT-input .form-control {
    background-color: #3f3f3f;
    color: #fff;
    border: none;
}

#modal-2 .modal-content {
    height: 55%;
    background-color: #323232;
    color: #fff;
}

#errors-list-modal .modal-content {
    background-color: #323232;
    color: #fff;
}

#modal-2 .table {
    color: #fff;
}

#modal-2 .table thead th {
    border: none;
}

#modal-2 .table td {
    border: none;
}

#detailsEvent .modal-content {
    height: 55%;
}

#detailsEventAdmin .modal-content {
    height: 55%;
}

#calendar-card {
    height: 100%;
    width: 100%;
    background-color: #323232;
    color: #fff;
}

#calendar {
    height: 100%;
}

#__BVID__34.form-control.form-control-sm.text-center {
    background-color: #323232;
    color: #fff;
    border: #3f3f3f;
}

.b-form-spinbutton {
    background-color: #323232;
    color: #fff;
    border: #323232;
}

.b-form-spinbutton :focus {
    background-color: #323232;
    color: #fff;
    border: #323232;
}

.b-form-spinbutton svg {
    color: #fff;
}

.b-form-spinbutton.form-control.d-inline-flex.flex-column.b-time-hours {
    background-color: #3f3f3f;
    color: #fff;
    border: none;
}

#detailsEvent .modal-content {
    background-color: #323232;
    color: #fff;
}

#detailsEventAdmin .modal-content {
    background-color: #323232;
    color: #fff;
}

.b-form-btn-label-control.form-control[aria-disabled=true] {
    background-color: #3f3f3f
}

#event_label.custom-select {
    background-color: #3f3f3f !important;
    color: #fff !important;
    border: none;
}

#event_time__dialog_.dropdown-menu.show {
    background-color: #3f3f3f;
    color: #fff;
}

.b-form-btn-label-control.form-control>.btn {
    color: #fff;
}

.b-form-btn-label-control.form-control {
    background-color: #3f3f3f;
    border: none;
}

.b-form-btn-label-control.form-control>.form-control {
    color: #fff;
}

#TT-input.form-control {
    background-color: #3f3f3f;
    border: none;
    color: #fff;
}

#TT-input.form-control :focus {
    background-color: #323232;
    border: none;
    color: #fff;
}

#TT-input.form-control.disabled-input {
    background-color: #323232;
    border: none;
    color: lightgray;
}

#createPointageModal___BV_modal_content_.modal-content {
    background-color: #323232;
    border: none;
    color: #fff;
    height: 55%;
}

.b-form-spinbutton.form-control.d-inline-flex.flex-column.b-time-minutes {
    background-color: #3f3f3f;
    color: #fff;
    border: none;
}

#event_hour__dialog_.dropdown-menu.show {
    background-color: #323232;
    color: #fff;
    border: 1px solid lightgray;
}

.b-time .b-time-header output {
    background-color: #3f3f3f;
    color: #fff;
    border: lightgray
}

.btn.btn-outline-secondary.btn-sm {
    color: #fff;
    border: 1px solid lightgray;
}

#event_date__dialog_.dropdown-menu.show {
    background-color: #323232;
    color: #fff;
    border: 1px solid lightgray;
}
</style>
